import { DataStoreType } from "../stores/dataStore";

/**
 * Sanitizes the table data by removing any objects without IDs.
 *
 * @param {DataStoreType["data"]} tableData - The table data to sanitize.
 * @returns {DataStoreType["data"]} The sanitized table data.
 */
export default function sanitizeTableData(
    tableData: DataStoreType["data"]
): DataStoreType["data"] {
    return {
        folders: tableData?.folders
            ? sanitizeCollection(tableData.folders)
            : {},
        notes: tableData?.notes ? sanitizeCollection(tableData.notes) : {},
        tags: tableData?.tags ? sanitizeCollection(tableData.tags) : {},
        deleted: tableData?.deleted,
    };
}

/**
 * Sanitizes a collection by ensuring all objects have IDs and using those IDs as keys.
 *
 * @param collection - The collection to sanitize.
 * @returns A new collection with only valid objects keyed by their IDs.
 */
function sanitizeCollection<T extends { id: string }>(collection: {
    [id: string]: T;
}): { [id: string]: T } {
    const sanitized: { [id: string]: T } = {};

    Object.values(collection).forEach((item) => {
        if (item.id) {
            sanitized[item.id] = item;
        }
    });

    return sanitized;
}
